import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'relative',
    height: '100%',
    boxShadow: '0px 4px 4px 0px rgba(255, 255, 255, 0.25) inset',

    // On wide screens the panel used to claim at least 40rem (a third of a
    // 1920 px screen). Metadata and comments do not need that; the slide does.
    // The expanded slides list keeps the room its table needs.
    [theme.breakpoints.up('xl')]: {
      width: 'clamp(22rem, 24vw, 28rem)',

      '.slideList &': {
        width: 'auto',
        minWidth: '40rem',
      },
    },
  },
  tabContent: {
    height: 'calc(100% - 77px)',
    padding: '0 2rem',
    overflowY: 'auto',
    background: 'white',
    border: '1px solid #D1D1D1',
    borderTop: 'none',

    [theme.breakpoints.down('xl')]: {
      padding: '0 0.5rem',
      height: 'calc(100% - 56px)',
    },
  },
  mlModels: {
    margin: 0,
    padding: 0,
    [theme.breakpoints.down('laptop')]: {
      gap: '0.625rem',
    },
  },
}));

export const useScrollStyles = makeStyles()((theme) => ({
  root: {
    overflowY: 'auto',

    [theme.breakpoints.up('md')]: {
      listStyle: 'none',

      '&::-webkit-scrollbar, &::-webkit-scrollbar-track, &::-webkit-scrollbar-corner':
        {
          height: '1rem',
          width: '0.4rem',
          background: 'transparent',
        },

      '&::-webkit-scrollbar-button': {
        width: 0,
        height: 0,
      },

      '&::-webkit-scrollbar-thumb': {
        border: '6px solid transparent',
        borderRadius: '0.5rem',
        color: '#dadce0',
        background: '#dadce0',
        minHeight: 60,
        minWidth: 60,
      },

      '&::-webkit-scrollbar-thumb:hover': {
        color: '#80868b',
        background: '#80868b',
      },

      '&::-webkit-scrollbar-thumb:active': {
        color: '#5f6368',
        background: '#5f6368',
      },
    },
  },
}));
